/**
 * @desc: - 弹出框 (普通弹出框)
 * @param  {[STRING]} className： [顶层class]
 * @param  {[ARRAY]} suffix：     [支持的格式]
 * @param  {[ARRAY]} size:        [文件最大size -kb]
 * @param  {[FUNCTION]} callback: [点击确定之后的回调函数]
 * @param  {[bool]} display: [是否显示弹出框]
 * @author: ammo
 * @example:<FileLoader display = {this.state.display} callback={this.hide.bind(this)} suffix={['jpg','png']} />
 */
import React from 'react';
import ReactDOM from 'react-dom'
import { loadTextFile } from '../../helpers/unit'

export default class FileLoader extends React.Component {
  constructor(props) {
    super(props);
    this.handleLoadFile = this.handleLoadFile.bind(this);
  }
  
  componentDidMount(){
    let modalTop = (window.screen.height/2 - this.refs.fileLoaderModal.offsetHeight) + 'px';
    this.refs.fileLoaderModal.style.top = modalTop;
  }

  handleLoadFile(){
    const {suffix, size, callback} = this.props;
    const files = ReactDOM.findDOMNode( this.refs.filePath ).files;
    const file = files[0];
    let errors = null;
    // 空文件
    if (files.length === 0) {
      errors = '请先选择文件后载入';
    }else{
      const suffixChecker = _.includes(suffix,_.chain(file.name).split('.').last().value())
      // 格式错误
      if (!suffixChecker) {
        errors = '文件格式错误，只支持['+_.join(suffix, ',')+']类型文件';
      }
      // 文件大小错误
      if (file.size/1024 > Number(size)) {
        errors = '文件大小超出限制，最大' + size +'kb';
      }
      // 浏览器兼容
      if (typeof window.FileReader != 'function'){
        errors ='您的游览器不支持文件上传'
      }
    }
    // 显示错误信息
    if (errors) {
      if (this.timer) {window.clearTimeout(this.timer)}
      
      ReactDOM.findDOMNode( this.refs.errors ).innerHTML = errors;
      this.timer = _.delay(function(){
      
        ReactDOM.findDOMNode( this.refs.errors ).innerHTML = '';
      
      }.bind(this), 5000)

      return;
    }
    // 读取文件
    loadTextFile(file, callback)
  }

  render() {
    let { className, display, callback } = this.props;
    className = className || 'modal-original';
    const style = {
      display: display ? 'block' : 'none'
    }
    return (
      <div>
        <div className={className} style={style} ref="fileLoaderModal">
          <h3 className="title">载入文件</h3>
          <div id="block_content" className="content">
            <div className="detail">
              请选择你要载入的文件<br/>
              <input className='modal-file-loader' ref='filePath' type="file" /><br/>
              <div className='errors' ref='errors'></div>
            </div>
          </div>
          <div id="block_bottom" className="bottom">
            <input type="button" value="载入文件" onClick={this.handleLoadFile} className="submit"/>
            <input type="button" value="取消" onClick={callback} className="cancel"/>
          </div>
        </div>
      </div>
    );
  }
}
